// extracted by mini-css-extract-plugin
export default {"bgPicked":"dragContent_bgPicked__accUh","bgSelected":"dragContent_bgSelected__lSjWD"};